import React from "react";
import PageLayout from "../../layouts/PageLayout";
import { Box, Image } from "../../components/elements";

export default function ChangeLog() {
    return (
        <PageLayout>
            <Box className="mc-blank">
                <Image src="images/blank.webp" alt="blank" />
            </Box>
        </PageLayout>
    )
}